import compose from 'lodash/fp/compose';
import omit from 'lodash/omit';

import api from '../REST/api';
import {
  replaceNestedWithId,
  replaceNestedWithIds,
} from '../utils/replace-nested-with-id';

export const transformForRendering = model => {
  return compose([
    agreement => replaceNestedWithIds(agreement, 'brands'),
    agreement => replaceNestedWithId(agreement, 'owner'),
  ])(model);
};

export function getTransformedAgreement(args) {
  return api
    .getAgreement(args)
    .then(response => transformForRendering(response || {}));
}

export function transformForPatch(model) {
  return omit(model, [
    'id',
    'account',
    'owner',
    'brands',
    'created',
    'lastModified',
    'createdBy',
    'lastModifiedBy',
    'pool',
    'subPool',
  ]);
}
